import React, { useEffect, useState } from 'react';
import {
  DataTable,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableContainer,
  Pagination
} from 'carbon-components-react';
import { Header } from 'redux/member/types';
import DisplayEmailRow from './DisplayEmailRow';
import { SearchEmailResponse } from '../types';
import { direction_type } from '../types';
import { Attachment20 } from '@carbon/icons-react';
import { toLocalDateTimeFormatWithSeconds } from 'utilities/helper.util';
import { apiToUi } from './forms/statusData';

import EmptyStatePage from './EmptyState';

const PageSizes = [10, 20, 50];

interface Props {
  emails: Array<SearchEmailResponse> | null;
  pageInfo: any;
  direction: string;
  setApiError: any;
  handleSendToOther: Function;
}
const DisplayEmails: React.FC<Props> = ({
  emails,
  pageInfo,
  direction,
  setApiError,
  handleSendToOther
}) => {
  const [filteredEmails, setFilteredEmails] = useState<Array<any>>([]);
  useEffect(() => {
    const selectedEmails =
      emails?.map((email) => {
        let modifiedEmails: any = {
          ...email,
          sent: email?.sent
            ? toLocalDateTimeFormatWithSeconds(email?.sent)
            : '',
          id: email.id?.toString()
        };

        if (direction === direction_type.OUTBOUND) {
          const filteredStatus = email?.status ? apiToUi[email.status] : '';
          modifiedEmails = { ...modifiedEmails, status: filteredStatus };
        }
        return modifiedEmails;
      }) || [];

    setFilteredEmails(selectedEmails);
  }, [emails, direction]);

  const headers: Array<Header> = [
    {
      key: 'sent',
      header: 'Sent'
    },
    { key: 'to', header: 'Recipient' },
    { key: 'from', header: 'Sender' },
    { key: 'subject', header: 'Subject' },
    { key: 'attachment', header: 'A' },
    { key: 'status', header: 'Status' },
    { key: 'isResent', header: 'Is Resent' }
  ];

  return (
    <>
      <DataTable rows={filteredEmails || []} headers={headers}>
        {({ rows, getTableProps, getHeaderProps, getRowProps }: any) => {
          return (
            <TableContainer>
              <Table {...getTableProps()}>
                <TableHead>
                  <TableRow>
                    <TableHeader
                      key="sent"
                      {...getHeaderProps({ key: 'sent', header: 'Sent' })}
                    >
                      {direction === direction_type.INBOUND
                        ? 'Recieved'
                        : 'Sent'}
                    </TableHeader>
                    <TableHeader
                      key="to"
                      {...getHeaderProps({ key: 'to', header: 'Recipient' })}
                    >
                      Recipient/Sender
                    </TableHeader>
                    <TableHeader
                      key="subject"
                      {...getHeaderProps({ key: 'subject', header: 'Subject' })}
                    >
                      Subject
                    </TableHeader>
                    <TableHeader
                      key="attachment"
                      {...getHeaderProps({ key: 'attachment', header: 'A' })}
                    >
                      <Attachment20 />
                    </TableHeader>
                    {direction === direction_type.OUTBOUND && (
                      <TableHeader
                        key="status"
                        {...getHeaderProps({
                          key: 'status',
                          header: 'Status'
                        })}
                      >
                        Status
                      </TableHeader>
                    )}
                    <TableHeader />
                    <TableHeader />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row: any, index: any) => (
                    <DisplayEmailRow
                      row={row}
                      getRowProps={getRowProps}
                      key={index}
                      direction={direction}
                      setApiError={setApiError}
                      handleSendToOther={handleSendToOther}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          );
        }}
      </DataTable>

      {filteredEmails?.length < 1 && <EmptyStatePage />}
      {filteredEmails?.length > 1 && (
        <Pagination
          onChange={pageInfo.handleFetchNextPage}
          backwardText="Previous page"
          forwardText="Next page"
          itemsPerPageText="Items per page:"
          page={pageInfo.currentPage}
          pageNumberText="Page Number"
          pageSize={pageInfo.pageSize}
          pageSizes={PageSizes}
          totalItems={pageInfo.totalItems}
        />
      )}
    </>
  );
};
DisplayEmails.displayName = 'DisplayEmails';
export default DisplayEmails;
